import { FieldPasswordCompact, Pushbutton } from '@stratumn/atomic';

import { Box, ChangePassword, Logo } from 'components/ui';
import { ROUTE_MY_PROFILE } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router-dom';
import { SpanType, withSpanAsync } from 'tracing';
import { withRestClient, withUser } from 'wrappers';

import styles from './updatePassword.style';

export class UpdatePassword extends React.PureComponent {
  static propTypes = {
    classes: PropType.object.isRequired,
    history: PropType.object.isRequired,
    client: PropType.object.isRequired
  };

  state = {
    oldPassword: '',
    oldPasswordVisible: false,
    newPassword: '',
    submitted: false
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleOldPasswordChange = event =>
    this.setState({ oldPassword: event.target.value });
  handleNewPasswordChange = password =>
    this.setState({ newPassword: password });
  toggleOldPAsswordVisible = () =>
    this.setState({ oldPasswordVisible: !this.state.oldPasswordVisible });

  isActive() {
    const { submitted, oldPassword, newPassword } = this.state;
    return !submitted && !!oldPassword && !!newPassword;
  }

  updatePassword = async () =>
    withSpanAsync('updatePassword', SpanType.processing, async () => {
      const { user, client, history } = this.props;
      const { oldPassword, newPassword } = this.state;
      this.setState({ submitted: true });
      try {
        await client.updatePassword(user.email, oldPassword, newPassword);
        history.push(ROUTE_MY_PROFILE);
      } catch (err) {
        this.setState({ submitted: false });
      }
    });

  render() {
    const { classes } = this.props;
    const { oldPassword, oldPasswordVisible } = this.state;
    return (
      <>
        <Logo />
        <Box title="Update your password">
          <div className={classes.passwordLabel}>Current password</div>
          <FieldPasswordCompact
            data-testid="old-password"
            label="password"
            onValueChange={this.handleOldPasswordChange}
            onVisibilityChange={this.toggleOldPAsswordVisible}
            passwordIsVisible={oldPasswordVisible}
            value={oldPassword}
          />
          <div className={classes.passwordLabel}>New password</div>
          <ChangePassword onChange={this.handleNewPasswordChange} />
          <Pushbutton
            data-testid="button"
            disabled={!this.isActive()}
            onClick={this.updatePassword}
            primary
          >
            change password
          </Pushbutton>
        </Box>
      </>
    );
  }
}

export default compose(
  withRouter,
  withUser,
  withRestClient,
  injectSheet(styles)
)(UpdatePassword);
